import React, { useEffect, useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import "../turkeydrop/turkeydrop2025/turkeydrop2025.css";
import { CHOW_CALL_EVENTS } from "./chowCallEvents";

export default function ChowCallThankYou() {
  const location = useLocation();

  const { eventTitle, subtitle, venueName, dateLabel, timeLabel, orderId, backPath } = useMemo(() => {
    const params = new URLSearchParams(location.search);
    const eventKey = params.get("event");
    const currentOrderId = params.get("order_id");
    const event = Object.values(CHOW_CALL_EVENTS).find((item) => item.key === eventKey);

    return {
      eventTitle: event?.title || "Chow Call!",
      subtitle: event?.subtitle || "A Military Community Dinner",
      venueName: event?.venueName || "",
      dateLabel: event?.dateLabel || "",
      timeLabel: event?.timeLabel || "",
      orderId: currentOrderId || null,
      backPath: event?.path || "/chow-call-vfw981",
    };
  }, [location.search]);

  useEffect(() => {
    document.title = "Chow Call RSVP Confirmed";
  }, []);

  return (
    <main className="tdp-shell" style={{ display: "grid", placeItems: "center", padding: 24 }}>
      <article className="tdp-card" style={{ maxWidth: 720 }}>
        <Link
          to={backPath}
          style={{ textDecoration: "none", fontSize: 28, display: "inline-block" }}
          aria-label="Back to Chow Call event page"
        >
          ✅
        </Link>
        <h1 className="tdp-card-title" style={{ marginTop: 8 }}>
          {eventTitle}
        </h1>
        <p className="tdp-card-sub">{subtitle}</p>
        <p className="tdp-help" style={{ marginTop: 8 }}>
          Thanks for reserving your dinner spot. We’ve received your RSVP.
        </p>
        {(venueName || dateLabel || timeLabel) && (
          <div className="tdp-block">
            <h3>Event details</h3>
            <p style={{ margin: 0 }}>
              {venueName ? (
                <>
                  Venue: {venueName}
                  <br />
                </>
              ) : null}
              {dateLabel ? (
                <>
                  Date: {dateLabel}
                  <br />
                </>
              ) : null}
              {timeLabel ? <>Time: {timeLabel}</> : null}
            </p>
          </div>
        )}
        <p className="tdp-help" style={{ marginTop: 8 }}>
          Veterans and service members may attend with one guest. If you need to update your reservation, contact our events team.
        </p>
        {orderId && (
          <div className="tdp-block">
            <h3>Confirmation ID</h3>
            <p style={{ margin: 0 }}>
              <code>{orderId}</code>
            </p>
          </div>
        )}
        <div className="tdp-block">
          <h3>Need assistance?</h3>
          <p style={{ margin: 0 }}>
            For event support, email <a href="mailto:events@roadhomeprogram.org">events@roadhomeprogram.org</a> or call{" "}
            <a href="tel:13129428387">(312) 942-8387 (VETS)</a>.
          </p>
        </div>
        <p style={{ marginTop: 8 }}>
          <Link to={backPath}>Back to event page</Link>
        </p>
        <p className="tdp-help" style={{ marginTop: 8 }}>
          You can close this page now.
        </p>
      </article>
    </main>
  );
}
